import type { CountryCode } from "libphonenumber-js";
import { StateCreator } from "zustand";
import { Storage } from "../index";

export type ContactInfoType = {
	firstName?: string;
	lastName?: string;
	email?: string;
	phoneNumber?: string;
};

export type AddressInfoType = {
	address?: string;
	city?: string;
	zipcode?: string;
	countryCode?: CountryCode;
};

export type IDInfoType = {
	idCardType?: string;
	idCardNumber?: string;
	idCardIssueDate?: string;
	idCardIssuePlace?: string;
};

export type UserInfoSlice = {
	contactInfo?: ContactInfoType;
	addressInfo?: AddressInfoType;
	idInfo?: IDInfoType;
	setContactInfo: (contactInfo: Partial<ContactInfoType> | undefined) => void;
	setAddressInfo: (addressInfo: Partial<AddressInfoType> | undefined) => void;
	setIdInfo: (idInfo: Partial<IDInfoType> | undefined) => void;
	resetContactInfo: () => void;
	resetAddressInfo: () => void;
	resetIdInfo: () => void;
	resetUserInfo: () => void;
};

export const createUserInfoSlice: StateCreator<Storage, [], [], UserInfoSlice> = (set) => ({
	contactInfo: undefined,
	addressInfo: undefined,
	idInfo: undefined,

	setContactInfo: (contactInfo) =>
		set((state) => {
			if (contactInfo === undefined) return { ...state, contactInfo: undefined };
			return { ...state, contactInfo: { ...(state.contactInfo ?? {}), ...contactInfo } };
		}),
	setAddressInfo: (addressInfo) =>
		set((state) => {
			if (addressInfo === undefined) return { ...state, addressInfo: undefined };
			return { ...state, addressInfo: { ...(state.addressInfo ?? {}), ...addressInfo } };
		}),
	setIdInfo: (idInfo) =>
		set((state) => {
			if (idInfo === undefined) return { ...state, idInfo: undefined };
			return { ...state, idInfo: { ...(state.idInfo ?? {}), ...idInfo } };
		}),
	resetContactInfo: () => set((state) => ({ ...state, contactInfo: undefined })),
	resetAddressInfo: () => set((state) => ({ ...state, addressInfo: undefined })),
	resetIdInfo: () => set((state) => ({ ...state, idInfo: undefined })),
	resetUserInfo: () =>
		set((state) => ({
			...state,
			contactInfo: undefined,
			addressInfo: undefined,
			idInfo: undefined,
		})),
});
